import * as React from 'react';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import NewHFLLayout from './NewHFLLayout';
import { newHFLTypography } from '../../hd-ui-kit/NewHFLTheme';

const pageContentStyle = {
  position: 'relative',
  display: 'flex',
  flexDirection: { xs: 'column', lg: 'row' },
  alignItems: 'flex-start',
  gap: { xs: '48px', lg: '80px' },
  width: '100%',
  minHeight: { lg: 'max(820px, calc(49.73vw + 66px))' },
  boxSizing: 'border-box',
  paddingLeft: { xs: '20px', md: '80px' },
  paddingRight: { xs: '20px', md: '80px' },
  paddingTop: { xs: '40px', md: '72px' },
  paddingBottom: { xs: '56px', md: '96px' },
};

const eyebrowStyle = {
  ...newHFLTypography.eyebrowM,
  fontSize: '24px',
  lineHeight: '120%',
  letterSpacing: '-0.24px',
  marginBottom: { xs: '18px', md: '24px' },
};

const headingStyle = {
  ...newHFLTypography.headingXXL,
  fontSize: { xs: '42px', sm: '52px', md: '62px' },
  letterSpacing: { xs: '-1.26px', md: '-1.86px' },
  marginBottom: { xs: '24px', md: '50px' },
};

const confirmationStyle = {
  color: 'var(--Text-Default-Primary, #280F1C)',
  fontFamily: 'var(--sds-typography-family-sans, "TWK Lausanne", sans-serif)',
  fontSize: { xs: '18px', md: '20px' },
  fontStyle: 'normal',
  fontWeight: 250,
  lineHeight: '120%',
  letterSpacing: '-0.2px',
};

const recommendationStyle = {
  color: 'var(--Text-Default-Primary, #280F1C)',
  fontFamily: 'var(--sds-typography-family-serif, "ABC Marist", serif)',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: 350,
  lineHeight: '125%',
  letterSpacing: 0,
};

function SubmitInterestConfirmationPage() {
  return (
    <NewHFLLayout>
      <Box component="main" sx={pageContentStyle}>
        <Box sx={{ position: 'relative', zIndex: 1, width: { xs: '100%', lg: '50%' }, maxWidth: { lg: '700px' } }}>
          <Box>
            <Typography component="p" sx={eyebrowStyle}>
              Thank You!
            </Typography>
            <Typography component="h1" sx={headingStyle}>
              We have your information. Here&apos;s what&apos;s next:
            </Typography>
            <Typography component="p" sx={confirmationStyle}>
              You have been added to Heidrick&apos;s candidate pool where our search consultants can search
              from. Our search consultants will initiate contact if additional information is required or if
              you have been identified as someone who is being considered as a candidate for one of our
              clients.
            </Typography>
          </Box>

          <Typography
            component="p"
            sx={{
              ...recommendationStyle,
              position: 'relative',
              zIndex: 1,
              marginTop: '250px',
            }}
          >
            To increase visibility across executive search firms, we recommend you submit your resume to
            BlueSteps, the executive career service of the Association of Executive Search and Leadership
            Consultants (AESC).{' '}
            <Link
              href="https://www.bluesteps.com/partner/heidrick"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: 'inherit',
                font: 'inherit',
                textDecoration: 'underline',
                textUnderlineOffset: '2px',
              }}
            >
              Learn more at BlueSteps.
            </Link>
          </Typography>
        </Box>
        <Box
          component="img"
          src={`${window.location.origin}/res/hd-ui-kit-images/newHFLDotMatrix.svg`}
          alt=""
          aria-hidden="true"
          sx={{
            display: { xs: 'none', lg: 'block' },
            position: 'absolute',
            top: '66px',
            right: '2.7%',
            width: '37%',
            height: 'auto',
          }}
        />
      </Box>
    </NewHFLLayout>
  );
}

export default SubmitInterestConfirmationPage;
